export default __webpack_public_path__ + "images/loggedout/review-images/star_rating-6e935a2afb6a0b7226e54c2cf08ccf62.png";